import React from 'react'
import Errors from '../errors'

const ErrorsPt = () => {
    return <Errors languageCode="pt" />
}

export default ErrorsPt
